export const contactPreferenceOptions = {
  slack: 'Slack',
  whatsApp: 'WhatsApp',
  telegram: 'Telegram',
  others: 'Others'
}

export const enInterestedOptions = {
  mediaBuyManagement: 'Media Buying Management',
  mobileAdIntelligence: 'Mobile Ad Intelligence',
}

export const cnInterestedOptions = {
  mediaBuyManagement: '广告智能投放管理',
  mobileAdIntelligence: '广告数据洞察分析',
}

export const enDescList = [
  {
    title: 'Global Market Insights',
    desc: 'Explore how advertising strategies evolved across key regions, with South America leading in creative volume and mature markets adopting more balanced ad formats.',
  },
  {
    title: 'Emerging Creative Trends',
    desc: 'See how hybrid ad formats and AI-generated creatives are reshaping engagement and boosting ad performance across genres.',
  },
  {
    title: 'Genre-Level Analysis',
    desc: 'Examine ad distribution and creative dynamics in top-performing categories like Puzzle, Strategy, and Casino.',
  },
  {
    title: 'Case Studies & Best Practices',
    desc: 'Learn from success stories such as Kingshot, Coin Master, and Screwdom 3D, showcasing how diverse UA strategies drive sustained growth.',
  },
];

export const cnDescList = [
  {
    title: '全球市场全景洞察',
    desc: '解析主要区域广告策略变迁，南美以创意数量领跑，欧美成熟市场侧重广告形式均衡，为区域投放提供依据。',
  },
  {
    title: '创意趋势前沿解读',
    desc: '深入剖析混合广告形式与 AI 生成创意的应用价值，为游戏开发者提供创意灵感。',
  },
  {
    title: '细分品类精准分析',
    desc: '聚焦益智、策略等热门品类，拆解广告投放与创意规律，赋能垂直领域从业者。',
  },
  {
    title: '标杆案例实战借鉴',
    desc: '结合 Kingshot 等知名案例，分享多元 UA 策略落地方法与增长逻辑。',
  },
];